import { VueConstructor } from 'vue';
import { Vue } from 'vue-property-decorator';

import Slick from "vue-slick";
import VueEasyLightbox from 'vue-easy-lightbox'

import OCKurukuru from './OCKurukuru.vue';
import OCButton from './OCButton.vue';
import OCButtonSmall from './OCButtonSmall.vue';
import OCLink from "./OCLink.vue"
import OCTtlMain from './OCTtlMain.vue';
import OCTtlSub from './OCTtlSub.vue';
import OCTtlContent from './OCTtlContent.vue';
import OCContentBox from './OCContentBox.vue';
import OCAccordion from './OCAccordion.vue';
import OCTextBox from './OCTextBox.vue';
import OCFormLabel from './OCFormLabel.vue';
import OCRadio from './OCRadio.vue';
import OCRadioGroup from './OCRadioGroup.vue';
import OCMailAuthentication from './OCMailAuthentication.vue';
import OCUserData from "./OCUserData.vue"
import NewUser from "../views/mypage/inner/NewUser.vue"
import PassRemind from "../views/mypage/inner/PassRemind.vue"
import OCPrizeGroupTtl from "./OCPrizeGroupTtl.vue"
import OCPrizeCard from "./OCPrizeCard.vue"
import OCProductCard from "./OCProductCard.vue"

let DefaultComponents: { [name: string]: VueConstructor<Vue> } = {
    Slick,
    VueEasyLightbox,
    OCKurukuru,
    OCButton,
    OCButtonSmall,
    OCLink,
    OCTtlMain,
    OCTtlSub,
    OCTtlContent,
    OCContentBox,
    OCAccordion,
    OCTextBox,
    OCFormLabel,
    OCRadio,
    OCRadioGroup,
    OCMailAuthentication,
    OCUserData,
    NewUser,
    PassRemind,
    OCPrizeGroupTtl,
    OCPrizeCard,
    OCProductCard
};

export function AllComponents(): { [name: string]: VueConstructor<Vue> } {
    return DefaultComponents;
};
